import React, { Component } from 'react'

import TextEditor from '../TextEditor';

import ImageOnlyUpload from '../../pages/ImageOnlyUpload';

//moment import
import moment from "moment";

//Service import
import service from "../../services";

//Validation import
import SimpleReactValidator from "simple-react-validator";

//import AWS from "aws-sdk";
import AWS from "aws-sdk";

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import { withRouter } from 'react-router-dom';
import PopUpCustomAll from '../fpg/create/popUpCustomAll';
import ErrorPopUp from '../errorPopUp';
import ModalMessage from '../ModalMessage';
import commonImage from '../../commonImage';

let sub;

class OfferDisplayTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorPopup: false,
            messageModal: false,
            deleteId: '',
            isImage: false,
            eventTitle: "",
            eventDisplayTemplate: "Offer",
            eventDescription: EditorState.createEmpty(),
            eventDetail: EditorState.createEmpty(),
            selectPartnerFlag: false,
            imagePreloader: false,
            loaderFlag: false,
            offerOutboundUrl: '',
            keyEventThumbnailImage: [{
                _id: Math.random(),
                link: "",
                url: ""
            }]
        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        this.apiserve = new service();
    }

    componentDidMount = () => {
        this.getAllEvent();
        if (this.props.offerUserID) {
            this.getPerticularEvent();
        }
        document.body.addEventListener('click', this.bodyClick);
    };

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    // Body Click
    bodyClick = (e) => {
        if (document.querySelector('.popup_wrapper')) {
            if (!e.target.closest('.popup_wrapper')) {
                this.setState({
                    featurePopup: false,
                    titlePopup: false
                })
            }
        }
    }

    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    getAllEvent = () => {
        const { getLoginRole } = this.props
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "FestivalVillage|Event|createEvent":
                    this.setState({ loaderFlag: false });
                    if (!response.error) {
                        this.apiserve.success('Event Created successfully.')
                        this.props.history.push("/satellite-adminview");
                    } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })
                    }
                    break;
                case "FestivalVillage|SatelliteScreen|getSatelliteEventById":
                    if (response.data.offerDescription) {
                        const blocksFromHtml = htmlToDraft(response.data.offerDescription);
                        const { contentBlocks, entityMap } = blocksFromHtml;
                        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                        const editorState = EditorState.createWithContent(contentState);
                        this.setState({
                            editorState: editorState,
                        })
                    }
                    if (response.data.offerDetail) {
                        const blocksFromHtml = htmlToDraft(response.data.offerDetail);
                        const { contentBlocks, entityMap } = blocksFromHtml;
                        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                        const editorStateShortOffer = EditorState.createWithContent(contentState);
                        this.setState({
                            editorStateShortOffer: editorStateShortOffer,
                        })
                    }
                    this.setState({
                        eventId: response.data._id,
                        eventDisplayTemplate: response.data.eventDisplayTemplate,
                        eventTitle: response.data.offerTitle,
                        offerOutboundUrl: response.data.offerOutboundUrl,
                        keyEventThumbnailImage: response.data.keyEventThumbnailImage
                    })
                    this.setState({ loaderFlag: false })
                    break;
                case "FestivalVillage|Event|updateEvent":
                    this.setState({ loaderFlag: false });
                    if (!response.error) {
                        this.apiserve.success('Event Created successfully.')
                        this.props.history.push("/satellite-adminview");
                    } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })
                    }
                break;
                case "FestivalVillage|Event|Preview|create":
                    if (!response.error) {
                        this.setState({
                            loaderFlag:false,
                        },()=>{
                        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_FESTIVAL_VILLAGE + 'film-preview');
                        })
                    }
                    else
                    {
                        this.setState({
                            errorPopup:true,
                            errorMsg: response.data.error ? response.data.error : response.data 
                        })
                    }
                  break;
            }
        });
    };

    onEditorStateDescription = (editorState) => {
        this.setState({ editorState })
    }

    onEditorStateDetailOffer = (editorStateShortOffer) => {
        this.setState({ editorStateShortOffer })
    }

    getPerticularEvent = () => {
        const { offerUserID } = this.props;
        this.apiserve.sendevent("FestivalVillage|SatelliteScreen|getSatelliteEventById", {
            id: offerUserID,
        });
        this.setState({ loaderFlag: true })
    };

    createEventData = () => {
        const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
        const markup = draftToHtml(name);

        const nameShort = this.state.editorStateShortOffer ? convertToRaw(this.state.editorStateShortOffer.getCurrentContent()) : ''
        const markupShort = draftToHtml(nameShort);
        this.state.keyEventThumbnailImage.forEach(element => {
            delete element._id
        });

        let data = {
            offerTitle: this.state.eventTitle,
            offerDescription: markup,
            offerOutboundUrl: this.state.offerOutboundUrl,
            eventDisplayTemplate: this.props.eventDisplayTemplate ? this.props.eventDisplayTemplate : this.state.eventDisplayTemplate,
            offerDetail: markupShort,
            eventTypeTitle: "satellite",
            keyEventThumbnailImage: this.state.keyEventThumbnailImage
        };
        this.apiserve.sendevent("FestivalVillage|Event|createEvent", data);
    }

    updateEventData = () => {
        const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
        const markup = draftToHtml(name);

        const nameShort = this.state.editorStateShortOffer ? convertToRaw(this.state.editorStateShortOffer.getCurrentContent()) : ''
        const markupShort = draftToHtml(nameShort);

        let updateData = {
            id: this.state.eventId,
            offerTitle: this.state.eventTitle,
            keyEventThumbnailImage: this.state.keyEventThumbnailImage,
            offerDescription: markup,
            eventTypeTitle: "satellite",
            offerOutboundUrl: this.state.offerOutboundUrl,
            eventDisplayTemplate: this.props.eventDisplayTemplate ? this.props.eventDisplayTemplate : this.state.eventDisplayTemplate,
            offerDetail: markupShort
        };
        this.apiserve.sendevent("FestivalVillage|Event|updateEvent", updateData);
    }

    previewRecord = (e) => {
        e.preventDefault()
        let previewDetails = {}
        if (this.validator.allValid()) {
            this.setState({ loaderFlag: true });
            const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
            const markup = draftToHtml(name);
    
            const nameShort = this.state.editorStateShortOffer ? convertToRaw(this.state.editorStateShortOffer.getCurrentContent()) : ''
            const markupShort = draftToHtml(nameShort);
    
            previewDetails = {
              offerTitle: this.state.eventTitle,
              keyEventThumbnailImage: this.state.keyEventThumbnailImage,
              offerDescription: markup,
              eventTypeTitle: "satellite",
              offerOutboundUrl: this.state.offerOutboundUrl,
              eventDisplayTemplate: this.props.eventDisplayTemplate ? this.props.eventDisplayTemplate : this.state.eventDisplayTemplate,
              offerDetail: markupShort
            };
            if (this.state.eventId) previewDetails.id = this.state.eventId
            let previewString = this.apiserve.e(previewDetails)
            this.apiserve.sendevent("FestivalVillage|Event|Preview|create", {previewString});
        }else {
            this.setState({
                messageModal: true,
            })
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    submitFn = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({ loaderFlag: true });
            if (this.props.offerUserID) {
                this.updateEventData();
            } else {
                this.createEventData();
            }
        } else {
            this.setState({
                messageModal: true,
            })
            this.validator.showMessages();
            this.forceUpdate();
        }
    };
    ClosemessageModal = () => {
        this.setState({
            messageModal: false,
        })
    }

    cancelFn = () => {
        this.props.history.push('/satellite-adminview')
    };

     OnchangeImage = (e, id) => {
        const { name, value } = e.target
        this.state.keyEventThumbnailImage.forEach(image => {
            if (image._id === id) {
                image.url = value
            }

        });
        this.setState({})

    }

    handleImage(e, id) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 2048) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 2 MB'
                    })
                    return false;
                }
                if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                    setTimeout(() => {
                        this.imageUploadOne(file, id,event.target.result);
                    }, 0)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            })
        }
    }

    imageUploadOne = (file, id, img) => {
        const imagePreloaderId = `imagePreloader_${id}`
        const newState = { ...this.state }
        newState[imagePreloaderId] = true
        this.setState(newState)
        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
                this.state.keyEventThumbnailImage.forEach(image => {

                    const imagePreloaderId = `imagePreloader_${id}`
                    const newState = { ...this.state }
                    newState[imagePreloaderId] = false
                    this.setState(newState)
                    if (image._id === id) {

                        image.link = value
                    }

                });
                this.setState({})
            });
    };

    deleteImage = (e, id) => {
        this.setState({
          deleteImagePopup: true,
          deleteId: id
        })
    }
    OnchangeImage = (e, id) => {
        const { name, value } = e.target
        this.state.keyEventThumbnailImage.forEach(image => {
            if (image._id === id) {
                image.url = value
            }

        });
        this.setState({})

    }

    onChangeFile = (e, id) => {
        e.stopPropagation();
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file
                // base64: reader.result
            });
            if (
                (file && file.type === "image/png") ||
                (file && file.type === "image/jpg") ||
                (file && file.type === "image/jpeg")
            ) {
                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 2048) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 2 MB'
                    })
                    return false;
                }
                if (file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                    this.setState({ isImage: true })

                    setTimeout(() => {
                        this.uploadVideoImage(file, id,event.target.result);
                    }, 0)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            } else {
                if (file.size > 100e6) {
                    this.setState({
                        errorMsg: true,
                        errorMsgShow: "Please upload a video smaller than 100 MB"
                    });
                    return false;
                }

                if (file.type === "video/mp4") {

                    setTimeout(() => {
                        this.uploadVideoImage(file, id,event.target.result);
                    }, 0);
                    return false;
                } else {
                    this.setState({
                        errorMsg: true,
                        errorMsgShow: "Please upload only MP4 file"
                    });
                }
            }
        };
    };

    uploadVideoImage = (file, id,img) => {
        const imagePreloaderId = `imagePreloader_${id}`;
        const newState = { ...this.state, videoPreLoader: true };
        newState[imagePreloaderId] = true;
        this.setState(newState);
        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
            this.state.detailImageOrVideo.forEach(image => {
                const imagePreloaderId = `videoPreLoader_${id}`;
                const newState = { ...this.state };
                newState[imagePreloaderId] = false;
                this.setState(newState);

                if (image._id === id) {

                    image.link = value;
                }
            });
            this.setState({ videoPreLoader: false });
        });
    };

    insideFilechange = (e, id) => {
        const { name, value } = e.target
        this.state.detailImageOrVideo.forEach(image => {
            if (image._id === id) {

                image.url = value;
            }
        });
        this.setState({})
    }

    setDeleteImagePopup = (e, id) => {
        this.setState({
            deleteImagePopup: true,
            deleteId: id
        })
    }

    onDeleteImagePopup = () => {
        this.state.keyEventThumbnailImage.forEach(image => {
            if (image._id === this.state.deleteId) {
                image.link = "";
            }
        });

        this.setState({
            deleteImagePopup: false
        })
    }

    closeAdminUser = () => {
        this.setState({ deleteImagePopup: false })
    };

    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }

    render() {
        return (
            <section
                className="tab-panel screenigBlock_wrapper PanelBlock_wrapper"
            >
                <form className="w_100 ml_0">
                    <div className="ml_15">
                        <div className="EventTitle_block">
                            <div className="textarea_block form_group">
                                <h5 className="left_label required">Offer Title</h5>
                                <div className="form_group_textarea">
                                    <input
                                        type="text"
                                        name="eventTitle"

                                        value={this.state.eventTitle}
                                        onChange={this.onInputChange}
                                        autoComplete="off"
                                    />
                                    <span className="error"> {this.validator.message( "event title", this.state.eventTitle, "required" )} </span>
                                </div>
                            </div>
                        </div>
                        <div className="description_block">
                            <div className="textarea_block form_group">
                                <h5 className="left_label required">Offer Description </h5>
                                <div className="form_group_textarea editor_wrapper ml_25 editor_400">
                                    <TextEditor
                                        name="editorState"
                                        editorState={this.state.editorState}
                                        value={this.state.editorState}
                                        onEditorStateChange={(e) =>
                                            this.onEditorStateDescription(e)} />
                                        <span className="error ml_0"> {this.validator.message( "Offer Description", this.state.editorState, "required" )} </span>
                                </div>
                            </div>
                        </div>
                        <div className="description_block">
                            <div className="textarea_block form_group">
                                <h5 className="left_label required">Offer Detail </h5>
                                <div className="form_group_textarea editor_wrapper ml_25 editor_400">
                                    <TextEditor
                                        name="editorStateShortOffer"
                                        editorState={this.state.editorStateShortOffer}
                                        value={this.state.editorStateShortOffer}
                                        onEditorStateChange={(e) =>
                                            this.onEditorStateDetailOffer(e)} />
                                        <span className="error ml_0"> {this.validator.message( "Offer Detail", this.state.editorStateShortOffer, "required" )} </span>
                                </div>
                            </div>
                        </div>
                        <div className="EventTitle_block">
                            <div className="textarea_block form_group">
                                <h5 className="left_label required">Offer Outbound URL</h5>
                                <div className="form_group_textarea">
                                    <input
                                        type="text"
                                        name="offerOutboundUrl"
                                        value={this.state.offerOutboundUrl}
                                        onChange={this.onInputChange}
                                        autoComplete="off"
                                    />

                                    <span className="error"> {this.validator.message( "Offer Outbound url", this.state.offerOutboundUrl, "required|url" )} </span>
                                </div>
                            </div>
                        </div>
                        <div className="EventTitle_block">
                            <div className="textarea_block form_group mr_25">
                                <h5 className="left_label">Key Event Thumbnail Image</h5>
                            </div>
                            {this.state.keyEventThumbnailImage &&
                                this.state.keyEventThumbnailImage.map((item, index) => {
                                    const imagePreloaderState = `imagePreloader_${item._id}`
                                    return (
                                        <div className="file_upload_400">
                                            <div className="uploads_files">
                                                <ImageOnlyUpload
                                                    item={item._id}
                                                    handleImage={(e) => this.handleImage(e, item._id)}
                                                    deleteImage={(e) => this.deleteImage(e, item._id)}
                                                    iconDelete={true}
                                                    showDeleteIcon={item.link}
                                                    size="2"
                                                    id={item._id}
                                                    image={item.url}
                                                    value={item.link ? this.apiserve.imageUrl + item.link : item.url}
                                                    ImagePreLoader={this.state[imagePreloaderState]}
                                                    insideOnchange={(e) => this.OnchangeImage(e, item._id)}
                                                    isboth={false}
                                                />
                                            </div>
                                        </div>
                                    )
                                })}
                        </div>
                    </div>
                    <div className="text_center field_row w_100 buttons_outer mb_0">
                        <button className="grayBTN" type='button' onClick={() => this.cancelFn()}>Cancel</button>
                        <button className="uppercase prev_btn" type='button' onClick={(e)=>this.previewRecord(e)}>PREviEW</button>
                        <button className="orangeBTN" type='button' onClick={(e) => this.submitFn(e)}>Submit</button>
                    </div>

                </form>
                {this.state.deleteImagePopup
                    ? <PopUpCustomAll
                        HeaderName="Delete Image?"
                        insideDetails="Are You Sure ?"
                        insideData="You want to delete this image"
                        popupState={() => this.closeAdminUser()}
                        yesPopUp={() => this.onDeleteImagePopup()} />
                    : ""
                }
                {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }
                {this.state.messageModal &&
                    <ModalMessage messageModal={this.state.messageModal} withoutEmail="Few or all of the required fields are missing. Please scroll up and check to add and confirm and resubmit" ClosemessageModal={this.ClosemessageModal} />
                }
            </section>
        )
    }
}
export default withRouter(OfferDisplayTemplate)
